import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";
import { CHECKOUT_RETURN_FLAG } from "./app.constants";
import { closeAllOverlays } from "./app.helpers";

export function bindOpenChatFromLocation({
  location,
  loadChat,
  setScreen,
  nav,
}) {
  const openChatId = location.state?.openChatId;
  if (!openChatId) return;

  (async () => {
    try {
      await loadChat(openChatId);
      setScreen("chat");
    } finally {
      nav(".", { replace: true, state: null });
    }
  })();
}

export function bindAuthChanged({
  resetSession,
  setIsLoggedIn,
  setAuthReady,
  setFavoriteIds,
  setFavoriteItems,
  setCartOpen,
  setProductOpen,
  setSheetProduct,
  setCatalogOpen,
  setPresetModalOpen,
  setDeliveryOpen,
  setAwaitingCheckout,
}) {
  let firstAuthCheck = true;

  return onAuthStateChanged(auth, (user) => {
    console.log("👤 auth changed", user);

    const loggedIn = !!user;

    setIsLoggedIn(loggedIn);
    setAuthReady(true);

    if (firstAuthCheck) {
      firstAuthCheck = false;
      return;
    }

    if (!loggedIn) {
  resetSession();

  closeAllOverlays({
    setCartOpen,
    setProductOpen,
    setSheetProduct,
    setCatalogOpen,
    setPresetModalOpen,
    setDeliveryOpen,
    setAwaitingCheckout,
  });

  setFavoriteIds([]);
  setFavoriteItems([]);
  return;
}

setFavoriteIds([]);
setFavoriteItems([]);
  });
}

export function restoreAfterCheckoutReturn({
  cartItemsLength,
  setCheckoutLoading,
  setPresetModalOpen,
  setDeliveryOpen,
  setAwaitingCheckout,
  setScreen,
  setCartOpen,
}) {
  const pending = sessionStorage.getItem(CHECKOUT_RETURN_FLAG);
  if (!pending) return;

  sessionStorage.removeItem(CHECKOUT_RETURN_FLAG);

  setCheckoutLoading(false);
  setPresetModalOpen(false);
  setDeliveryOpen(false);
  setAwaitingCheckout(false);

  if ((cartItemsLength || 0) > 0) {
    setScreen("chat");
    setCartOpen(true);
  }
}